import { Message } from 'element-ui'

const defaultError = 'Произошла ошибка'

export const showDefaultErrorMessage = () => {
  return showErrorMessage(defaultError)
}

export const showErrorMessage = (message: string) => {
  return Message({
    message: message,
    type: 'error',
    duration: 5000,
  })
}
